import { base64ToPK, BaseModel, parseArray, parseAttr, rProperty } from '../data-model';
import { BLanguage } from '../language/language';
import { BTeam, BUser } from 'app/modules/data-model/user/user';
import { BInquirer } from 'app/modules/data-model/inquirer/inquirer';
import { BInquiry } from 'app/modules/data-model/interaction/interaction';
import { BEmail } from 'app/modules/data-model/email/email';
import { BPhone } from 'app/modules/data-model/phone/phone';
import { BAddress } from 'app/modules/data-model/address/address';
import { BEvent } from '../event/event';
import { BAdditionalCase } from '../interaction/interaction.service';

export class BNewInteraction extends BaseModel {
  @rProperty() id: string;
  title: string;
  @rProperty(Date) createdTs: Date;
  @rProperty(Date) editedTs: Date;
  @rProperty() outgoingChannel: string;
  @rProperty() outgoingBccList: string; //comma separated values
  @rProperty() outgoingCcList: string; //comma separated values
  @rProperty() productList: string;
  @rProperty() categoryList: string;
  @rProperty() topicList: string;
  @rProperty() statusLabel: string;
  @rProperty() confidential: boolean;
  @rProperty() answerUnavailable: boolean;
  @rProperty() needSrd: boolean;

  isPublic: boolean;
  priority: string;
  isInlineEdit?: boolean = false;

  // Relations
  inquirer: BInquirer;
  insertedBy: BUser;
  assignedTo: BUser;
  team: BTeam;
  language: BLanguage;
  editedBy: BUser;
  inquiries: BInquiry[];
  event: BEvent;
  additionalCases: BAdditionalCase[];

  constructor(json: any) {
    super(json);
    this.init(json);
  }

  init(json: any) {
    this.team = parseAttr<BTeam>(json, BTeam, 'team');
    this.event = parseAttr<BEvent>(json, BEvent, 'event');
    this.editedBy = parseAttr<BUser>(json, BUser, 'editedBy');
    this.insertedBy = parseAttr<BUser>(json, BUser, 'insertedBy');
    this.assignedTo = parseAttr<BUser>(json, BUser, 'assignedTo');
    this.language = parseAttr<BLanguage>(json, BLanguage, 'language');
    this.inquirer = parseAttr<BInquirer>(json, BInquirer, 'inquirer');
    if (!this.inquirer) {
      this.inquirer = new BInquirer({
        emails: [new BEmail('')],
        phones: [new BPhone('')],
        addresses: [new BAddress('')],
      });
    }
    this.inquiries = parseArray<BInquiry>(json, BInquiry, 'inquiries');
  }

  static fromRest(json: any): BNewInteraction {
    if (json) {
      json.inquirer = BInquirer.fromRest(json.inquirer);
      if (!json.inquirer) {
        json.inquirer = new BInquirer({
          emails: [new BEmail('')],
          phones: [new BPhone('')],
          addresses: [new BAddress('')],
        });
      }
      json.team = BTeam.fromRest(json.team);
      json.event = BEvent.fromRest(json.event);
      json.language = BLanguage.fromRest(json.language);
      json.inquiries = BInquiry.fromRestArray(json.inquiries);
      json.insertedBy = BUser.fromRest(json.insertedBy);
      json.assignedTo = BUser.fromRest(json.assignedTo);
      return Object.assign(new BNewInteraction({}), json);
    }
    return json;
  }

  static fromRestArray(json: any[]): BNewInteraction[] {
    return json && json.map((v) => BNewInteraction.fromRest(v));
  }

  pk(): number {
    if (!this.id) {
      return null;
    }
    return base64ToPK(this.id);
  }
}
